import React from "react";
import "./parchase.css";
import { useEffect, useState, useRef } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { useUser } from "../../../context/UserContext";

const ParchaseBatch = () => {
  const [Batch, setBatch] = useState(null);
  const [loading, setLoading] = useState(true);
  const [selectedBatches, setSelectedBatches] = useState([]);

  // login student
  const container =
    window !== undefined ? () => window().document.body : undefined;
  const { user } = useUser();

  // payment redirect validations
  const batchIdsParam = selectedBatches.map((batch) => batch.pack_id);
  const batchIds = JSON.stringify(batchIdsParam);

  const handleProceedToPay = () => {
    if (totalPrice === 0) {
      alert("First select Package");
      return; // stop here, no redirect
    }
    const url = `https://topfaculty.co.in/icici/?amount=${encodeURIComponent(
      totalPrice
    )}&userId=${encodeURIComponent(user.user_id)}&user=${encodeURIComponent(
      user.user_name
    )}&batchIds=${encodeURIComponent(batchIds)}`;
    // redirect manually

    window.open(url, "_blank");
  };

  useEffect(() => {
    axios
      .get(`https://topfaculty.co.in/api/package_list.php`)
      .then((response) => {
        console.log(response.data);
        setBatch(response.data);
        setLoading(false);
      })
      .catch((error) => {
        console.log("Error Fetching Batch Data", error);
        setLoading(false);
      });
  }, []);

  // Toggle selection
  const handleCheckboxChange = (batch) => {
    setSelectedBatches((prev) => {
      const exists = prev.find((b) => b.pack_name === batch.pack_name);
      if (exists) {
        return prev.filter((b) => b.pack_name !== batch.pack_name);
      } else {
        return [...prev, batch];
      }
    });
  };

  // Calculate total price
  const totalPrice = selectedBatches.reduce(
    (sum, b) => sum + parseFloat(b.price),
    0
  );
  const handleRemoveBatch = (batchToRemove) => {
    setSelectedBatches((prev) =>
      prev.filter((batch) => batch.pack_name !== batchToRemove.pack_name)
    );
  };

  return (
    <>
      <div id="rs-latest-news" className="rs-courses-details ">
        <img
          src="assetsfront/images/bt.jpg"
          alt="Banner Image"
          style={{
            marginTop: "0%",
            width: "100%",
            // height: "200px",
            objectFit: "cover",
          }}
        />
        <div className="container">
          <div className="row mt-4">
            <h1
              className="title text-center "
              style={{ fontWeight: "700" }}
            >
              Our : <span class="info-color">Batches </span>
            </h1>
          </div>

          <div className="row">
            {/* Left side - Batches */}
            <div className="col-lg-8 ">
              <div className="cart-table-wrapper ">
                <h2 className="section-title"> All Batches Or Package</h2>
                <div className="table-responsive ">
                  <table
                    id="example"
                    className="table table-striped"
                    style={{
                      width: "100%",
                    }}
                  >
                    <thead
                      style={{
                        color: "black",
                        background: "#f7b205",
                      }}
                    >
                      <tr>
                        <th>Package Name</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {loading ? (
                        <span
                          style={{
                            fontWeight: "bold",
                            color: "#002347",
                            fontSize: "30px",
                          }}
                        >
                          Please Wait
                          <span className="dot-loader">
                            {[...Array(9)].map((_, i) => (
                              <span className="dot" key={i}></span>
                            ))}
                          </span>
                        </span>
                      ) : Batch && Batch.length > 0 ? (
                        Batch.map((batch, index) => (
                          <tr className="cart-item" key={index}>
                            <td className="cart-product">
                              <div className="profile-body">
                                <div className="profile-details">
                                  <h5>
                                    ({index + 1}) <span>{batch.pack_name}</span>
                                  </h5>
                                  <small style={{ color: "gray" }}>
                                    Package Details:{batch.pack_details}
                                  </small>
                                  <p className="description">
                                    Subjects: {batch.sub_subjects}
                                  </p>
                                </div>
                              </div>
                              <div className="clearfix" />
                            </td>

                            <td style={{ width: "30%" }}>
                              <h5>Medium: {batch.medium}</h5>
                              <h5>Price: ₹ {batch.price}</h5>
                              {/* <button className="mt-1 purchase-btn">
                                {" "}
                                <input type="checkbox"></input> Add{" "}
                              </button> */}
                              <button
                                className="purchase-btn"
                                onClick={() => handleCheckboxChange(batch)}
                                style={{
                                  backgroundColor: selectedBatches.some(
                                    (b) => b.pack_name === batch.pack_name
                                  )
                                    ? "red"
                                    : "green",
                                  color: selectedBatches.some(
                                    (b) => b.pack_name === batch.pack_name
                                  )
                                    ? "white"
                                    : "white",
                                }}
                              >
                                <input
                                  style={{
                                    transform: "scale(1.5)", // Increase size (1 = normal)
                                    marginRight: "8px", // Optional spacing
                                  }}
                                  type="checkbox"
                                  checked={selectedBatches.some(
                                    (b) => b.pack_name === batch.pack_name
                                  )}
                                  onChange={() => handleCheckboxChange(batch)}
                                  onClick={() => handleCheckboxChange(batch)}
                                />{" "}
                                {selectedBatches.some(
                                  (b) => b.pack_name === batch.pack_name
                                )
                                  ? "Remove"
                                  : "Add"}
                              </button>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <p
                          className="mt-2"
                          style={{ textAlign: "center", fontWeight: "800" }}
                        >
                          No Batches available
                        </p>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            {/* Right side - Price Summary */}
            <div
              className="col-lg-4"
              style={{ position: "sticky", top: "80px", right: "0" }}
            >
              <div className="cart-summary">
                <h3 className="section-title">
                  <i sty class="fa fa-money" aria-hidden="true"></i> Price
                  Details
                </h3>
                {/* Selected Batches Table */}
                <h3 className="mt-4">Selected Batches</h3>

                {selectedBatches.length > 0 ? (
                  <>
                    <table
                      className="table table-striped"
                      style={{
                        boxShadow:
                          "rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px",
                      }}
                    >
                      <thead style={{ color: "white", background: "#001db0" }}>
                        <tr>
                          <th>Batch Name</th>
                          <th>Price</th>
                          <th> </th>
                        </tr>
                      </thead>
                      <tbody>
                        {selectedBatches.map((batch, i) => (
                          <tr key={i} className="cart-item">
                            <td>{batch.pack_name}</td>
                            <td>₹{batch.price}</td>
                            <td>
                              <i
                                className="fa fa-times"
                                aria-hidden="true"
                                style={{ cursor: "pointer", color: "red" }}
                                onClick={() => handleRemoveBatch(batch)}
                              ></i>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </>
                ) : (
                  <p style={{ color: "gray", fontStyle: "italic" }}>
                    No batches selected.
                  </p>
                )}

                <div className="summary-row total">
                  Total Price: ₹{totalPrice.toFixed(2)}
                </div>

                {user ? (
                  <Link>
                    <button
                      className="checkout-btn"
                      onClick={handleProceedToPay}
                    >
                      Proceed to Pay →
                    </button>
                  </Link>
                ) : (
                  <Link to={`../studentlogin`}>
                    <button className="checkout-btn">Proceed to Pay →</button>
                  </Link>
                )}

                {/* <Link
                  to={`https://topfaculty.co.in/icici/?amount=${totalPrice}&user=${userId}`}
                >
                  <button className="checkout-btn">Proceed to Pay →</button>
                </Link> */}
                <img
                  src="https://cdn.myshoptet.com/usr/www.led-grower.eu/user/documents/upload/img/logo-platebni-karty.png"
                  alt="Pay"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ParchaseBatch;
